import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ApiError } from '@smena/ui';
import { fetchMe, login, logout, type AdminUser } from './api';

const ME_KEY = ['admin', 'me'] as const;

/** Текущий админ. При 401 - data === null (не throw); редирект делает ProtectedRoute. */
export function useMe() {
  return useQuery<AdminUser | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await fetchMe();
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: login,
    onSuccess: (user) => qc.setQueryData(ME_KEY, user),
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      qc.setQueryData(ME_KEY, null);
      qc.clear();
    },
  });
}
